/* Skills list */
const skills = [
    {
        "name": "Python",
        "skillLevel": 90
    },
    {
        "name": "Java",
        "skillLevel": 90
    },
    {
        "name": "C",
        "skillLevel": 90
    },
    {
        "name": "C++",
        "skillLevel": 90
    },
    {
        "name": "PHP",
        "skillLevel": 90
    },
    {
        "name": "GraphQL",
        "skillLevel": 90
    },
    {
        "name": "HTML/CSS",
        "skillLevel": 90
    },
    {
        "name": "JavaScript",
        "skillLevel": 90
    },
    {
        "name": "TypeScript",
        "skillLevel": 90
    },
    {
        "name": "SQL",
        "skillLevel": 90
    },
    {
        "name": "Flask",
        "skillLevel": 90
    },
    {
        "name": "React",
        "skillLevel": 90
    },
    {
        "name": "Node.js",
        "skillLevel": 90
    },
    {
        "name": "Next.js",
        "skillLevel": 90
    },
    {
        "name": "MySQL",
        "skillLevel": 90
    },
    {
        "name": "MongoDB",
        "skillLevel": 90
    },
    {
        "name": "Swift",
        "skillLevel": 70
    },
    {
        "name": "Kotlin",
        "skillLevel": 70
    },
    {
        "name": "Firebase",
        "skillLevel": 70
    },
    {
        "name": "Docker",
        "skillLevel": 70
    },
    {
        "name": "Kubernetes",
        "skillLevel": 70
    },
    {
        "name": "PyTorch",
        "skillLevel": 70
    },
    {
        "name": "C#",
        "skillLevel": 60
    },
    {
        "name": "Rust",
        "skillLevel": 60
    },
    {
        "name": "Assembly",
        "skillLevel": 60
    }
];

export default skills;